export const OC_TOKEN = "OCToken";